export default "__VITE_ASSET__kxd80Pyr__"